import Heading from 'presentation/shared/components/Heading'
import React from 'react'
import DoctorImage from '../../../assets/doctor.png'
import * as S from '../styled'
import { SurgeryJourney } from '../index'
import theme from 'presentation/styles/theme'

export function PreoperativeConsultationsAndExams({
  goBack,
  goNext
}: SurgeryJourney) {
  return (
    <S.Wrapper>
      <S.Header>
        <svg
          width="10"
          height="18"
          viewBox="0 0 10 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={goBack}
        ></svg>
        <Heading as="h1" size="large">
          Consultas e Exames pré-operatórios
        </Heading>
        <svg
          width="10"
          height="18"
          viewBox="0 0 10 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={goNext}
        >
          <path
            d="M2 16L7 9L2 2"
            stroke={theme.colors.primary}
            strokeWidth="4"
          />
        </svg>
      </S.Header>

      <p>
        A etapa de consultas e exames pré-operatórios antes de uma cirurgia é
        fundamental para avaliar a saúde do paciente. Durante a consulta, ocorre
        uma revisão detalhada do histórico médico, exame físico e discussão do
        procedimento. Exames, como análises de sangue e testes de imagem, são
        realizados para identificar riscos.
      </p>
      <br />
      <p>
        Essa fase permite comunicação aberta entre paciente e equipe médica,
        esclarecendo dúvidas e obtendo consentimento informado, contribuindo
        para uma cirurgia segura e bem-sucedida.
      </p>
      <br />

      <S.Image src={DoctorImage} alt="Médico fazendo anotações" />
    </S.Wrapper>
  )
}
